import { autoinject, bindable, bindingMode, transient, customElement } from 'aurelia-framework';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { I18N } from 'aurelia-i18n';
import { PromptController } from 'Code/Prompts/PromptController';
import { Router } from 'aurelia-router';
import { ValidationHelper } from 'Code/Helpers/ValidationHelper';
import { AuthService } from 'DataAccessLayer/Services/AuthService';

declare var Swiper;

@autoinject
@customElement('aircraft-list')
export class AircraftListCustomElement extends BaseCustomElement {

  @bindable({ defaultBindingMode: bindingMode.toView }) operatorId: number = null;
  @bindable({ defaultBindingMode: bindingMode.toView }) aircraftList: Array<any> = [];

  protected dataService: DataService = null;
  protected authService: AuthService = null;

  protected router: Router = null;
  protected element: any = null;
  protected i18n: I18N = null;
  protected schema: Object = null;
  protected customElement: any = null;
  protected uid: string = null;
  private swiper: any = null;


  constructor(dataService: DataService, element: Element, router: Router, promptController: PromptController, i18n: I18N, validationHelper: ValidationHelper, authService: AuthService,) {
    super();

    this.dataService = dataService;
    this.element = element;
    this.router = router;
    this.i18n = i18n;
    this.authService = authService;
  }
  async bind() {

  }

  attached() {
    this.swiper = new Swiper(".swiper", {
      slidesPerView: 1,
      spaceBetween: 12,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  detached() {
    this.swiper.destroy(true, true);
  }

}
